module.exports = {
  common: {
    zhanghu: 'アカウント情報',
    dengjibenren: '登録本人確認書類',
    biangengmima: 'パスワードの変更',
    xiadanjilu: '買取履歴',
    zhucedenglu: 'ログイン | 新規登録',
    login: 'ログイン',
    zhuxiao: 'ログアウト',
  },
  shopList: {
    phone: '携帯電話',
    jiu: 'ゲーム機',
    jiadian: '家電製品',
    search: '検索',
    mingcheng: '商品名',
    color: '色を選択'
  },
  button: {
    sure: '確認',
    cancel: 'キャンセル',
    chongzhi: 'リセット',
    fanhui: '買取商品に戻る',
    denglu: 'ログイン',
    zhuce: '新規登録',
  },
  login: {
    email: 'メールアドレスを入力してください',
    password: 'パスワードを入力してください',
  },
  category: {
    jixugouwu: '買取商品に戻る',
    danjia: '単価',
    shuliang: '数量',
    xiaoji: '小計',
    myCategory: '予約カード',
    yuyuefanhao: '予約番号',
    hejijine: '合計金額',
    shuliang: '数量',
    yuyue: '予約',
  },
  reservation: {
    yuyueshangpinliebiao: '予約商品リスト',
    yuyuegouwuche: "予約カート",
    yuyuexinxitianxie: '予約情報記入',
    goumaifangfa: '購入方法',
    zhifufangfa: '支払い方法',
    fapiao: '請求書',
    xingming: '名前',
    xingbie: '性別',
    youxiang: 'メールアドレス',
    dizhi: 'アドレス',
    huikuandizhi: '振込先住所',
    dingdanxinxi: 'オーダー情報',
    dingdantijiaochenggong: 'オーダーの送信に成功しました',
    dingdanbianhao: '注文番号',
    riqi: '日付',
    jine: '金額',
    goumaishuliang: '購入数量',
    shopping: '店舗',
    inputBankName: '銀行名',
    inputBankCode: '銀行コード',
    inputBankBranchName: '支店名',
    inputBankBranchCode: '支店コード',
    inputBankAccNumber: '口座番号',
    inputBankAccName: '口座名義',
    inputBankAccType: '口座種別',
    inputBankAccTypeSavings: '普通',
    inputBankAccTypeCurrent: '当座',
  },
  info: {
    zhanghuxinxi: 'アカウント情報：',
    youxiang: 'メールアドレス：',
    benrenquerenwenjian: '本人確認書類',
    benrenquerenwenjiandengji: '本人確認書類登録',
    mima: 'パスワード：',
    xiugaimima: 'パスワード変更',
    yuanmima: '現在のパスワード',
    xinmima: '新しいパスワード',
  },
  register: {
    fapiaoyewubianma: '請求書ビジネス番号',
    email: 'メールアドレス',
    emailqueren: 'メールアドレス確認',
    mima: 'パスワード',
    mimaqueren: 'パスワード確認',
    shenfenzhengxinxi: '本人確認書類',
    youjiandizhi: 'メ-ルアドレス',
    xing: '姓',
    ming: '名',
    xingbie: '性別',
    shengrinianyueri: '生年月日',
    dianhuafanhao: '電話番号',
    zhiye: '職業',
    youbianfanhao: '郵便番号',
    zhusuo: '住所',
    querenzhuce: '登録確認',
  },
  rules: {
    qingxuanze: '必須項目です',
  }

}
